import React from 'react';
import { string, func, shape, arrayOf, object } from 'prop-types';
import ListDropdown from '@alltrails/shared/components/ListDropdown';
import ChevDown12 from '@alltrails/shared/components/ChevDown12';
import { FEED_LABEL_MAP } from '../../utils/blazes_helper';
import styles from './styles/styles.module.scss';

const FeedToggleDropdown = ({ activeFeedKey, feedOptions, handleLinkClick, alignment }) => {
  const label = FEED_LABEL_MAP[activeFeedKey];

  const dropdownLinks = feedOptions.map(({ links }) => {
    return { href: links.start.href, label: links.start.label };
  });

  return (
    <ListDropdown
      anchorElement={
        <button type="button" className={styles.button}>
          <p>{label}</p> <ChevDown12 />
        </button>
      }
      links={dropdownLinks}
      handleLinkClick={handleLinkClick}
      alignment={alignment}
    />
  );
};

FeedToggleDropdown.propTypes = {
  activeFeedKey: string.isRequired,
  handleLinkClick: func.isRequired,
  alignment: string.isRequired,
  feedOptions: arrayOf(shape({ label: string, name: string, links: object })).isRequired
};

export default FeedToggleDropdown;
